<template>
    <div class="pagination container-fluid" v-if="lastPage > 1">
        <div class="row justify-content-center w-100">
          <ul>
            <router-link :to="{name: rota, query: parametros(pg)}" v-for="(pg, index) in lastPage" :key="index">
              <li :class="{'sellected': page === pg}">
                {{pg}}
              </li>
            </router-link>
          </ul>
        </div>
    </div>
</template>

<script>
export default {
  props: ['page', 'lastPage', 'rota'],
  methods: {
    parametros (page, filter) {
      let parametros = {}
      if (page) {
        parametros.page = page
      }
      if (this.$route.query.category) {
        parametros.category = this.$route.query.category
      }
      if (this.$route.query.filter) {
        parametros.filter = this.$route.query.filter
      }
      if (this.$route.query.delivered) {
        parametros.delivered = this.$route.query.delivered
      }
      if (this.$route.query.for_sale) {
        parametros.for_sale = this.$route.query.for_sale
      }
      return parametros
    }
  }
}
</script>
<style lang="scss">
@import '../assets/scss/_variables.scss';

.pagination {
  margin-top: 20px;
  float: right;

  ul{
    float: right;

    li{
      padding: 5px;
      color: $primary;
      font-size: 18px;
      float: left;
      font-weight: 600;
      border: 1px $primary solid !important;
      padding: 8px 12px 6px 12px !important;
      transition: all 0.3s;
      position: relative;
      margin: 0 2px;
      cursor: pointer;
      width: initial;

      &:hover{
        transition: all 0.3s;
        background: $primary;
        color: #fff;
      }

      &:before{
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        border: 2px #fff solid;
      }
    }
    .sellected {
      background: $primary;
      color: #fff;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/paginacao.vue